import React from 'react'
import { useNavigate } from 'react-router-dom';

import PreviewOption from '@/components/preview/PreviewOption'
import ImportItemCard from "@components/import/ImportItemCard";

import './styles/import-item.scss'

function ImportItem() {
    const navigate = useNavigate();

    const onCancel = () => {
        navigate('/')
    }

    const onImport = () => {
        navigate('/')
    }

    return (
        <div className="import-item">
            <div className="import-item__header">
                <PreviewOption label="Kinopoisk ID" value={"m44123"} />
                <PreviewOption label="IMDB" value={"m44123"} />
            </div>

            <ImportItemCard />

            <div className={'import-item__control'}>
                <button className="app-btn" onClick={onCancel}>
                    Отмена
                </button>
                <button className="app-btn" onClick={onImport}>
                    Импортировать
                </button>
            </div>
        </div>
    )
}

export default ImportItem;